import React from 'react';
import { useSelector } from 'react-redux';

export function SoldOutStamp() {
    const hasLoadedPackages = useSelector(state => state.data.has_loaded_packages);
    const totalTicketsAvailable = useSelector(state => state.data.total_ticket_available);

    if (!hasLoadedPackages || totalTicketsAvailable > 0) {
        return null;
    }

    return (
        <div className="sold-out">
            Slutsålt!
        </div>
    );
}
